import FormRow from 'components/forms/FormRow';
import { _t } from 'lang';
import { useClient } from 'providers/client/ClientProvider';
import { usePriceList } from 'providers/price-list/PriceListProvider';
import PriceListSelect from 'components/selects/PriceListSelect';
import { useEffect, useMemo } from 'react';
import { useData } from '../../../providers/DataProvider';

/**
 * The client of a cost estimate.
 */
export default function CostEstimatePriceList() {
  const { clientId } = useClient();
  const { updateData } = useData();
  const { priceListId, priceList, setPriceListId } = usePriceList();

  const filter = useMemo(() => ({ 'client_id.eq': clientId }), [clientId]);

  useEffect(() => {
    if (priceList) {
      updateData({ currency: priceList.currency });
    }
  }, [priceList, updateData]);

  return (
    <FormRow
      label={_t('Price list')}
      input={
        <PriceListSelect
          value={String(priceListId)}
          onChange={(value) => setPriceListId(Number(value))}
          actionFilter={filter}
        />
      }
    />
  );
}
